module.exports = __webpack_public_path__ + "5da83cfb4883a59354abeff852cb7394.png";